import React from "react";

type Props = {
  skuID: string;
  isRX: boolean;
  highlightPartOfId?: boolean;
};
const SkuID = ({ skuID, isRX, highlightPartOfId = true }: Props) => {
  const skuIDStr = skuID.toString();

  return (
    <div>
      <span>
        {isRX && highlightPartOfId ? (
          <>
            {skuIDStr.slice(0, 4)}
            <b style={{ fontSize: "1.5em" }}>{skuIDStr.slice(4)}</b>
          </>
        ) : (
          <b>{skuIDStr}</b>
        )}
      </span>
    </div>
  );
};

export default SkuID;
